export default "__VITE_ASSET__DjIsI$EA__"